import React from 'react';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import InlineSeparator from '../../InlineSeparator';
import TooltipWrapper from '../../TooltipWrapper';

const useStyles = makeStyles(theme => ({
  eventDetails: {
    display: 'flex',
    flexDirection: 'column',
    [`${theme.breakpoints.up('md')}`]: {
      marginLeft: theme.spacing(1),
    },
  },
  airports: {
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightMedium,
  },
  flightNumber: {
    fontWeight: theme.typography.fontWeightMedium,
  },
}));

const EventDetails = ({ event }) => {
  const classes = useStyles();

  const flightNumber = (
    <Typography
      className={classes.flightNumber}
      align="center"
      variant="caption"
    >
      {
        <TooltipWrapper title="Flight number">
          {event.flightNumber}
        </TooltipWrapper>
      }
    </Typography>
  );

  const airports = (
    <Typography align="center" className={classes.airports} variant="caption">
      <TooltipWrapper title="Inbound airport">
        {event.inboundAirport}
      </TooltipWrapper>
      <InlineSeparator />
      <TooltipWrapper title="Airport">{event.airport}</TooltipWrapper>
      <InlineSeparator />
      <TooltipWrapper title="Outbound airport">
        {event.outboundAirport}
      </TooltipWrapper>
    </Typography>
  );

  return (
    <div className={classes.eventDetails}>
      {flightNumber}
      {airports}
    </div>
  );
};

export default EventDetails;
